import SectionMessage from '@atlaskit/section-message';
import Image from '@atlaskit/image';
import iconTileAnatomyLight from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-anatomy-light.png";
import iconTileAnatomyDark from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-anatomy-dark.png";
import iconTileSizeLight from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-size-light.png";
import iconTileSizeDark from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-size-dark.png";
import iconTileColorLight from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-color-light.png";
import iconTileColorDark from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/icon-tile-color-dark.png";
import iconTileBoldDo from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-bold-do.png";
import iconTileBoldDont from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-bold-dont.png";
import iconTileHeightDo from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-height-do.png";
import iconTileHeightDont from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-height-dont.png";
import iconTilePairingDo from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-pairing-do.png";
import iconTilePairingDont from "../../../../../../packages/design-system/icon/constellation/icon-tile/images/do-donts/icon-tile-pairing-dont.png";
import * as React from 'react';
export default {
  SectionMessage,
  Image,
  iconTileAnatomyLight,
  iconTileAnatomyDark,
  iconTileSizeLight,
  iconTileSizeDark,
  iconTileColorLight,
  iconTileColorDark,
  iconTileBoldDo,
  iconTileBoldDont,
  iconTileHeightDo,
  iconTileHeightDont,
  iconTilePairingDo,
  iconTilePairingDont,
  React
};